import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import cuid from 'cuid';
import { getBackgroundColor } from './accordionUtil';
import { withVDSManager } from '@vds-core/utilities';
/* this is a test, dont merge */

var propTypes = {
  /**
   * @deprecated
   */
  backgroundColor: PropTypes.string,

  /**
   * Children for the Accordion can only be AccordionItem.
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated
   */
  className: PropTypes.string,

  /**
   * Add this prop if you want your accordion to have an inverted color scheme. When using the inverted prop Accordion must be in a container element with a black background.
   */
  inverted: PropTypes.bool,

  /**
   * @deprecated type
   */
  single: PropTypes.bool,

  /**
   * If set to 'single', the Accordion will open only one AccordionItem at a time. If a different AccordionItem is opened, any other AccordionItem that is open will automatically be closed. If set to 'multi', multiple AccordionItem can be open at a time.
   */
  type: PropTypes.oneOf(['single', 'multi']),

  /**
   * @ignore
   */
  testMode: PropTypes.bool,

  /**
   * @ignore
   */
  borderBottom: PropTypes.bool,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-level': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-position': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-datatrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-cta': PropTypes.string,

  /**
   * Allows a unique id to be passed to the component and applied to the outermost wrapper.
   */
  id: PropTypes.string,

  /**
   * Allows the top line of the Accordion to render with 'heavy' or 'light' thickness
   */
  topLineType: PropTypes.oneOf(['light', 'heavy'])
};
var defaultProps = {
  backgroundColor: null,
  className: null,
  inverted: false,
  single: false,
  type: 'multi',
  testMode: false,
  borderBottom: false,
  topLineType: 'heavy'
};
/* Necessary to make sure that accordion doens't shrink on a flex container */

var AccordionWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccordionWrapper",
  componentId: "sc-1xsaiao-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n"])));
var AccordionList = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccordionList",
  componentId: "sc-1xsaiao-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 100%; /* Necessary so component takes full width of parent component */\n"])), function (props) {
  return getBackgroundColor(props);
});

var Accordion = /*#__PURE__*/function (_Component) {
  _inherits(Accordion, _Component);

  var _super = _createSuper(Accordion);

  function Accordion() {
    var _this;

    _classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "accordionItemChildren", {});

    _defineProperty(_assertThisInitialized(_this), "idPrefix", "".concat(cuid().substr(-6)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeID: null
    });

    _defineProperty(_assertThisInitialized(_this), "updateActiveAccordion", function (id) {
      _this.setState({
        activeID: id
      });

      window.scrollBy(0, 1);
      window.scrollBy(0, -1);
    });

    return _this;
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          backgroundColor = _this$props.backgroundColor,
          children = _this$props.children,
          className = _this$props.className,
          inverted = _this$props.inverted,
          single = _this$props.single,
          type = _this$props.type,
          testMode = _this$props.testMode,
          borderBottom = _this$props.borderBottom,
          calcTrigger = _this$props.calcTrigger,
          typescale = _this$props.typescale,
          calcTypography = _this$props.calcTypography,
          buttonHitArea = _this$props.buttonHitArea,
          focusState = _this$props.focusState,
          triggerHeight = _this$props.triggerHeight,
          activeState = _this$props.activeState,
          caretTrigger = _this$props.caretTrigger,
          iconData = _this$props.iconData,
          mediumIcon = _this$props.mediumIcon,
          caretAnimation = _this$props.caretAnimation,
          transitionStates = _this$props.transitionStates,
          triggerActiveAnimation = _this$props.triggerActiveAnimation,
          detailPaddingTop = _this$props.detailPaddingTop,
          colorConfig = _this$props.colorConfig,
          triggerSize = _this$props.triggerSize,
          linkStandalone = _this$props.linkStandalone,
          bodyConfig = _this$props.bodyConfig,
          id = _this$props.id,
          topLineType = _this$props.topLineType,
          analyticsTrack = _this$props['data-analyticstrack'],
          track = _this$props['data-track'],
          clickStream = _this$props['data-clickstream'],
          cta = _this$props['data-sitecat-cta'],
          dataTrack = _this$props['data-sitecat-datatrack'],
          position = _this$props['data-sitecat-position'],
          level = _this$props['data-sitecat-level'];
      var groupCount = 0; // Count and ID of AccordionItems

      return /*#__PURE__*/React.createElement(AccordionWrapper, null, /*#__PURE__*/React.createElement(AccordionList, {
        id: id,
        backgroundColor: backgroundColor,
        className: className,
        inverted: inverted
      }, React.Children.map(children, function (child, index) {
        if (!child || 'boolean' === typeof child) return null;
        var childElement = child.type === React.Fragment ? child.props.children : child;
        childElement = childElement instanceof Array ? childElement[0] : childElement;
        var childType = childElement.type.componentType ? childElement.type.componentType : ''; // We only want to add our stuff to the AccordionItem

        if (childType === 'AccordionItem') {
          return /*#__PURE__*/React.cloneElement(childElement, {
            key: index + 1,
            activeID: _this2.state.activeID,
            backgroundColor: childElement.props.backgroundColor ? childElement.props.backgroundColor : backgroundColor,
            onClick: _this2.updateActiveAccordion,
            groupIndex: groupCount,
            groupId: "".concat(_this2.idPrefix, "_").concat(groupCount++),
            // <- Increment after assignment so we still get a zero
            inverted: inverted,
            getAccordionItemRef: _this2.getAccordionItemRef,
            clickHandler: _this2.updateActiveAccordion,
            type: type,
            single: single,
            testMode: testMode,
            borderBottom: borderBottom,
            colorConfig: colorConfig,
            buttonHitArea: buttonHitArea,
            calcTrigger: calcTrigger,
            typescale: typescale,
            calcTypography: calcTypography,
            focusState: focusState,
            triggerHeight: triggerHeight,
            triggerSize: triggerSize,
            activeState: activeState,
            caretTrigger: caretTrigger,
            iconData: iconData,
            mediumIcon: mediumIcon,
            caretAnimation: caretAnimation,
            transitionStates: transitionStates,
            triggerActiveAnimation: triggerActiveAnimation,
            linkStandalone: linkStandalone,
            bodyConfig: bodyConfig,
            track: track,
            clickStream: clickStream,
            analyticsTrack: analyticsTrack,
            dataTrack: dataTrack,
            cta: cta,
            position: position,
            level: level,
            topLineType: topLineType
          });
        } // If not an AccordionItem, just return the child as is


        return child;
      })));
    }
  }]);

  return Accordion;
}(Component);

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
export default withVDSManager(Accordion);